import { Modal } from '@clearcover/atlas';
import { findConflictingDraft, PolicyContext } from 'Policies/utils';
import { ConfirmationModal } from 'Shared/components';
import { useLazyApi } from 'Shared/services/Api';
import React, { FC, useContext } from 'react';
import { useParams } from 'react-router-dom';

export const ConflictingDraftModal: FC<{
  renderToggle: (openModal: () => void) => JSX.Element;
  onApprove: () => void;
}> = ({ onApprove, renderToggle }) => {
  const { id: policyId } = useParams<{
    id: string;
  }>();
  const {
    details: { draftType },
    draftList,
    removeDraft,
  } = useContext(PolicyContext);

  const conflictingDraft = findConflictingDraft(
    draftType ?? 'mid_term',
    draftList
  );

  const [{ loading, error }, executeTerminateDraft] = useLazyApi({
    url: `/policies/${policyId}/drafts/${conflictingDraft?.id}/terminate`,
    method: 'POST',
  });

  if (!conflictingDraft) {
    return renderToggle(onApprove);
  }

  const verbiage =
    conflictingDraft?.type === 'renewal_quote'
      ? {
          header: 'A quote exists on the renewal term',
          body:
            'Changes cannot be made on your active term when a quote is present on the renewal term. Please discard the renewal quote to continue.',
          confirmText: 'Discard Quote',
        }
      : {
          header: 'A draft exists on the active term',
          body:
            'Changes cannot be made on your renewal when a draft is present on the active term. Please discard the draft to continue.',
          confirmText: 'Discard Draft',
        };

  return (
    <Modal toggle={renderToggle}>
      {close => (
        <ConfirmationModal
          onSubmit={() => {
            executeTerminateDraft().then(() => {
              removeDraft(conflictingDraft.id);
              close();
              onApprove();
            });
          }}
          close={close}
          isSubmitting={loading}
          error={error?.message}
          headerText={verbiage.header}
          bodyText={verbiage.body}
          confirmText={verbiage.confirmText}
          backText="Cancel"
        />
      )}
    </Modal>
  );
};
